import { App, Button, Popconfirm, Space } from 'antd'
import { FC } from 'react'
import useErrorModal from '../../../hooks/api/use-error-modal'
import {
    useApproveAssignmentTaskMutation,
    useRejectAssignmentTaskMutation,
} from '../../../store/api/tasks-api'
import Task from '../../../types/api/task'

interface CuratorTaskActionsProps {
    task: Task
}

const CuratorTaskActions: FC<CuratorTaskActionsProps> = ({ task }) => {
    const { message } = App.useApp()
    const [approve, approveState] = useApproveAssignmentTaskMutation()
    const [reject, rejectState] = useRejectAssignmentTaskMutation()

    useErrorModal(approveState, 'Не удалось согласовать задание')
    useErrorModal(rejectState, 'Не удалось отклонить задание')

    const isDone = task.taskStatus === 'Завершена' || task.taskStatus === 'Отменена'
    const loading = approveState.isLoading || rejectState.isLoading

    if (isDone) {
        return null
    }

    const onApprove = async () => {
        const res = await approve(task.documentId)
        if (!('error' in res)) {
            message.success('Задание согласовано')
        }
    }

    const onReject = async () => {
        const res = await reject(task.documentId)
        if (!('error' in res)) {
            message.success('Задание отклонено')
        }
    }

    return (
        <Space size={8}>
            <Button type='primary' size='small' loading={loading} onClick={onApprove}>
                Согласовать
            </Button>
            <Popconfirm
                title='Отклонить задание?'
                description='Статус станет «Отклонено»'
                okText='Отклонить'
                cancelText='Отмена'
                okButtonProps={{ danger: true }}
                onConfirm={onReject}
            >
                <Button danger size='small' loading={loading}>
                    Отклонить
                </Button>
            </Popconfirm>
        </Space>
    )
}

export default CuratorTaskActions
